/**
 * @generated SignedSource<<3baffbd65b7946f42c363c4c4c064c9d>>
 * @relayHash 2ee61623ca50c42eaefaf8b4a4b50bfd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a4032c3b535f4bb4c9e0f712d6c0e16c6dd229341561a835fc849d8e6bb8c287

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "a4032c3b535f4bb4c9e0f712d6c0e16c6dd229341561a835fc849d8e6bb8c287",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
